"use server";

import { newId, rateLimited, sendStrictMail } from "@cw/forms";
import { clientKey } from "@/lib/client-key";
import { buildGetStartedEmails } from "@/emails/get-started";
import {
  createPhaseOneService,
  type PhaseOneRaw,
  type PhaseOneResult,
} from "@/lib/phase-one-service";

const submit = createPhaseOneService({
  buildEmails: buildGetStartedEmails,
  sendMail: async (message) => {
    // Use the connected account until the no-reply account is available.
    // Strict mail validates SMTP_FROM and retains the PSCX Edge display name.
    await sendStrictMail({ ...message, from: undefined });
  },
  newId,
  isRateLimited: (key) => rateLimited(key, 10),
});

export async function submitPhaseOne(raw: PhaseOneRaw): Promise<PhaseOneResult> {
  return submit(raw, await clientKey("pscx:phase-one"));
}
